import { fireLinkTag } from '../../../../features/analytics/tagManager';

export const tagATBValidationError = (errorMessage) => {
  const utagData = {
    event_name: 'add to bag error',
    link_name: 'add to bag error',
    error_category: '',
    error_code: [''],
    error_label: ['CHECKOUT_SDD_TIP'],
    error_message: [`${errorMessage}`],
    error_misc: [''],
    error_scope: [''],
  };
  fireLinkTag(utagData);
};
